/**
 * Type of operation which is creating a task
 */
export enum TaskCreationOperation {
    /**
     * Creating tasks when creating a leave
     */
    CreatingLeave,

    /**
     * Creating a single task from the main popup
     */
    FromMainPopup,

    Other,
}
